// extracted by mini-css-extract-plugin
module.exports = {"root":"root__2rWO_","returning-provider-logo":"returning-provider-logo__2uLrt"};